import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteReturnReason } from './DeleteReturnReason';
import { FormReturnReason } from './FormReturnReason';

export const ModalReturnReason = (props) => {

    const {
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveDelete, saveCreate, saveUpdate,
        id_return_reason, reason, validaciones, is_sample,
        is_work_order, is_tracking, is_send

    } = props;

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true} size='lg' >
            <ModalHeader toggle={toggle} className="bg-primary">
                {"Catalógo General"}
            </ModalHeader>
            {
                method === "create"
                    ? <FormReturnReason
                        button="Guardar"
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate, is_sample, is_work_order, is_tracking, is_send }}
                    />
                    : (method === "update")

                        ?
                        <FormReturnReason
                            button="Actualizar"
                            {...{
                                toggle, loading, handleInputChange, id_return_reason, reason, validaciones, methodAction: saveUpdate, is_sample, is_work_order, is_tracking, is_send
                            }}
                        />
                        :
                        <DeleteReturnReason
                            {...{ toggle, loading, saveDelete, reason }}
                        />


            }
        </Modal>

    )
}
